// extracted by mini-css-extract-plugin
module.exports = {"word":"word--+r96A","pict":"pict--Le1cB"};